import { Controller } from "stimulus"
export default class extends Controller {
  static get targets() {
    return [];
  }
  initialize(){
    let btnHTML =  `<div class="quantity-nav"><div   data-action="click->number-input#up"  
                    class="quantity-button quantity-up">+</div><div  data-action=" click->number-input#down" 
                   class="quantity-button quantity-down">-</div></div>`;
    let node = document.createRange().createContextualFragment(btnHTML);

    this.input = this.element.querySelector('input');
    this.element.appendChild(node);  
    this.min = this.input.getAttribute('min'),
    this.max = this.input.getAttribute('max');

  }

 up(e) {
        var oldValue = parseFloat(this.input.value);
        if (oldValue >= this.max && this.max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        this.input.value = newVal;
       var event = new Event('change');
       this.input.dispatchEvent(event);

 }

down(e){
        var oldValue = parseFloat(this.input.value);
        if (oldValue <= this.min && this.min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        this.input.value = newVal;
       var event = new Event('change');
       this.input.dispatchEvent(event);



 }

}

